module.exports = __webpack_public_path__ + "img/erudio_certificate.6475b98f.svg";